import styled from "styled-components";

/**
 * Inline flex row holding the two independent controls (Follow + Message) in the
 * `full` variant. The controls themselves are the shared Button atom; this only
 * owns their spacing so alignment stays consistent everywhere it's dropped in.
 * `$gap` (gordon-0923-P1, supersedes the ISP-9999 #965 8px rule): the two 44px
 * icon buttons' hover-circle boxes must TOUCH (0px between their edges) on
 * every surface — "the Gap is WAY TOO BIG". Default 0 so every caller is
 * flush unless it explicitly opts into more room.
 */
export const Row = styled.div`
  display: inline-flex;
  /* $stack (QA-1014): render the two controls VERTICALLY stacked (notification
     follow rows want Follow above Message on the right); default stays a row so
     every other caller is byte-identical. */
  flex-direction: ${({ $stack }) => ($stack ? "column" : "row")};
  align-items: ${({ $stack }) => ($stack ? "stretch" : "center")};
  gap: ${({ $gap }) => ($gap != null ? $gap : 0)}px;
  flex-shrink: 0;
`;
